import { Page } from '@/components/dashboard/page';
import { resolver, Form, SelectField, TextField } from 'ht-sdk/react/forms';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button, Col, Heading, Row } from 'ht-sdk/react';
import { useForm } from 'react-hook-form';
import { UserCreateSchema, userRoleOptions } from '@shared/modelTypes/user-types';
import { auth } from '@/auth';
import { toast } from 'sonner';

export const Route = createFileRoute('/dashboard/users/new')({
	component: RouteComponent,
});

function RouteComponent() {
	const form = useForm({
		resolver: resolver(UserCreateSchema),
	});

	const router = useRouter();

	const errors = form.formState.errors;
	console.log('all the errors', errors);

	return (
		<Page>
			<Heading>New User</Heading>
			<Form
				methods={form}
				onSubmit={async (data) => {
					console.log('onSubmit', data);
					const res = await auth.register(data);
					if (res.success) {
						toast.success('User created successfully');
						router.navigate({ to: '/dashboard/users' });
					} else {
						toast.error('Failed to create user: ' + res.message);
					}
				}}
				onInvalid={(errors) => {
					console.log('got errors', errors);
				}}
			>
				<Col gap={3}>
					<Row gap={3}>
						<TextField name="firstName" label="First Name" placeholder="First Name" />
						<TextField name="lastName" label="Last Name" placeholder="Last Name" />
					</Row>
					<SelectField name="role" label="Role" options={userRoleOptions} />
					<TextField name="email" label="Email" placeholder="Email" />
					<TextField optional type="password" name="password" label="Password" placeholder="Password" />
					<Button type="submit" className="cursor-pointer">
						Create
					</Button>
				</Col>
			</Form>
		</Page>
	);
}
